jQuery(document).ready(function() {

    // number controls on pageload
    $('.form-field .number-control').each( function() {
        var $display = $(this).find('.number-control__current-value');
        var $input = $(this).find('.number-control__input');
        var inputVal = parseInt($input.val());
        var min = $input.data('min');
        var max = $input.data('max');
        var $sum = $(this).closest('.form-field').find('.'+$input.data('sum-elem'));
        var $controlMinus = $(this).find('.control.control--minus');
        var $controlPlus = $(this).find('.control.control--plus');

        // prevent preset values from exceeding min or max values
        if( inputVal < min ) {
            inputVal = min;
        }
        if( inputVal > max ) {
            inputVal = max;
        }

        // set preset values in control current value
        $display.html(inputVal);

        // add btn disabled classes when min or max is reached
        if( inputVal == min ) {
            $controlMinus.addClass('control--disabled');
        }
        if( inputVal == max ) {
            $controlPlus.addClass('control--disabled');
        }

        // calculate sum on pageload
        if( $sum.length ) {
            var currentVal = parseInt($sum.html());
            var newVal = currentVal + inputVal;

            $sum.html( newVal );

            if( newVal == 1 ) {
                $sum.siblings('.field-text').html( $sum.closest('.form-field__fake-input').data('text-single') );
            } else {
                $sum.siblings('.field-text').html( $sum.closest('.form-field__fake-input').data('text-multiple') );
            }

        }
    });

    // number controls on user action
    $('.form-field .number-control .number-control__controls .control').click( function(e) {
        e.preventDefault();

        var $wrapper = $(this).closest('.number-control');
        var $display = $wrapper.find('.number-control__current-value');
        var $input = $wrapper.find('.number-control__input');
        var inputVal = parseInt($input.val());
        var min = $input.data('min');
        var max = $input.data('max');
        var $sum = $(this).closest('.form-field').find('.'+$input.data('sum-elem'));

        if( $(this).hasClass('control--minus') ) {
            if( inputVal > min ) {
                var newVal = inputVal - 1;
                var controlPlus = $wrapper.find('.control.control--plus');

                if( controlPlus.hasClass('control--disabled') ) {
                    controlPlus.removeClass('control--disabled');
                }

                $input.attr('value',newVal).trigger('change');
                $display.html(newVal);

                // update sum
                if( $sum.length ) {
                    var currentVal = parseInt($sum.html());
                    var updatedVal = currentVal - 1;

                    $sum.html(updatedVal);

                    if( updatedVal == 1 ) {
                        $sum.siblings('.field-text').html( $sum.closest('.form-field__fake-input').data('text-single') );
                    } else {
                        $sum.siblings('.field-text').html( $sum.closest('.form-field__fake-input').data('text-multiple') );
                    }
                }

                if( newVal == min ) {
                    $(this).addClass('control--disabled');
                }
            }
        } else if( $(this).hasClass('control--plus') ) {
            if( inputVal < max ) {
                var newVal = inputVal + 1;
                var controlMinus = $wrapper.find('.control.control--minus');

                if( controlMinus.hasClass('control--disabled') ) {
                    controlMinus.removeClass('control--disabled');
                }

                $input.attr('value',newVal).trigger('change');
                $display.html(newVal);

                // update sum
                if( $sum.length ) {
                    var currentVal = parseInt($sum.html());
                    var updatedVal = currentVal + 1;

                    $sum.html(updatedVal);

                    if( updatedVal == 1 ) {
                        $sum.siblings('.field-text').html( $sum.closest('.form-field__fake-input').data('text-single') );
                    } else {
                        $sum.siblings('.field-text').html( $sum.closest('.form-field__fake-input').data('text-multiple') );
                    }
                }

                if( newVal == max ) {
                    $(this).addClass('control--disabled');
                }
            }
        }
    });

});